//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0],
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

//header image to be window height on homepage
if (document.getElementsByClassName('img-slide').length > 0) {
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for (let i = 0; i < headerImagesLength; i++) {
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// BOOKING
(function () {
	$(document).ready(function () {
		/* Properties Day's Calendar [Enable/Disable,ClassName,Tooltip] */

		var start = $("#arriveInput").attr("value");
		var end = $("#departureInput").attr("value");
		var firstClick = 0;
		var limitDate = $("#limitDate").attr("value").split(",");


		$("#datesCalendar").datepicker({
			minDate: start,
			numberOfMonths: 2,
			dateFormat: "mm/dd/yy",
			maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate("mm/dd/yy", start);
				var endDate = $.datepicker.parseDate("mm/dd/yy", end);

				if (date.getTime() == startDate.getTime()) {
					return [true, "start-day"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "end-day"];
					} else {
						if (
							date.getTime() > startDate.getTime() &&
							date.getTime() < endDate.getTime()
						) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var selectedDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					date
				);

				if (firstClick == 0) {
					start = date;
					end = date;
					firstClick = 1;
				} else {
					if (selectedDate <= start) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					firstClick = 0;
				}
				let arrayStartDate = start.split('/');
				let startDay = `${arrayStartDate[2]}-${arrayStartDate[0]}-${arrayStartDate[1]}`
				let arrayEndtDate = end.split('/');
				let endDay = `${arrayEndtDate[2]}-${arrayEndtDate[0]}-${arrayEndtDate[1]}`

				$("#arriveInput").attr("value", startDay);
				$("#departureInput").attr("value", endDay);
				$("#pickup").val(start + "   -   " + end);
			},
			onChangeMonthYear: function () {
				setTimeout(function () {
					calendarH();
				}, 80);
			},
		});
		var booking_date_format = "yy/mm/dd";
		var booking_min_date = "";
		var booking_allow_children = false;
		$("#pickup").mask("Z9-Z9-9999   -   Z9-Z9-9999", {
			translation: {
				Z: {
					pattern: /[0-9]/,
					optional: true,
				},
			},
		});

	});

	//dropdown for mobile
	document.querySelectorAll('.inner > ul > li > a').forEach(link => {
		link.addEventListener('click', e => {
			if (link.nextSibling.nextSibling != null) {
				document.querySelectorAll('.inner > ul > li').forEach(item => {
					if (link.parentNode !== item) item.classList.remove('js-submenu-show');
				});
				//remove this comment if you want show subnav for mobile
				e.preventDefault();
				link.parentNode.classList.toggle('js-submenu-show');
			}
		});
	});
	//add class for icon dropdown 
	document.querySelectorAll('.inner > ul > li > .sub-sub-menu').forEach(link => {
		let menu = link.parentNode.firstElementChild;
		menu.classList.add('ico-dropdown');
	})
	//--------------------

	window.onload = function () {
		let jBooking = document.querySelector(".js-booking");
		if (jBooking != undefined) {
			jBooking.addEventListener("click", function (e) {
				e.preventDefault();
				document.querySelector(".booking-block").classList.add("open");
			});
		}

		document.querySelector(".js-close").addEventListener("click", function (e) {
			e.preventDefault();
			document.querySelector(".booking-block").classList.remove("open");
		});
	};

	let buttonOffers = document.querySelectorAll(".js-booking-offers");
	if (buttonOffers != undefined) {
		buttonOffers.forEach(element => {
			element.addEventListener('click', function (e) {
				e.preventDefault();
				loadDatePicker(validationMonth(''));
				document.querySelector(".booking-block").classList.add("open");
			})
		});
	}

	//offer for item special
	let buttonOffersSpecial = document.querySelectorAll(".js-booking-accomodation");
	if (buttonOffersSpecial != undefined) {
		buttonOffersSpecial.forEach(element => {
			element.addEventListener('click', function (e) {
				e.preventDefault();
				//loadDatePicker(validationMonth(''));
				document.querySelector(".booking-block").classList.add("open");
			})
		});
	}

	resizeWindow();
	scrollW();

	window.addEventListener('scroll', function () {
		scrollW();
	})
	window.addEventListener('resize', function () {
		resizeWindow();
	});

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function () {
		if (!this.classList.contains('open')) {
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
			document.querySelector(".overlay").classList.add("open");
			const item = document.querySelectorAll("#burgerMenu .text")[0];
			item.textContent = "CLOSE";
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
			document.querySelector(".overlay").classList.remove("open");
			const item = document.querySelectorAll("#burgerMenu .text")[0];
			item.textContent = "MENU";
		}
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {
		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {
		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//script for show input when is mobile
	const inputDate = document.querySelectorAll(".date input")[0];
	if (inputDate != undefined) {
		inputDate.addEventListener("click", function () {
			if (this.getAttribute("type") === "date") {
				this.showPicker();
			}
		});
	}

	/* Accordion */
	var accordionItems = document.querySelectorAll('.accordion__item');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');
		});
	}
	//--------------

	/* Accordion EVENTS */
	var accordionItems = document.querySelectorAll('.accordion__events');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');
		});
	}
	//--------------

	/* Accordion MENU */
	var accordionItems = document.querySelectorAll('.quad-menus__menu-content-product');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');
		});
	}

	//--------------


	let item = document.querySelectorAll('.privary-navigation__submenu .active')[0];
	if (item != undefined) {
		let itemSubmenu = item.parentElement.parentElement.parentElement.firstElementChild;
		itemSubmenu.classList.add("active");
	}


	// Function for scroll in the view casino
	var data = document.URL
	console.log(data,'dos');
	let validationLastHash = data.split("#");
	if(validationLastHash[1]=''){
		if (data.indexOf('#') != -1) {
			data = data.split("#")[1]
			console.log(data,'data');
			var top_ele = $("#" + data).offset().top;
			$('html,body').animate({ scrollTop: top_ele - 150 }, 1500).delay(1000);
		}
	}
	//-------------------------------------

}());



function scrollW() {
	//check scroll down or up for header styles
	let header = document.getElementById('header');
	let st = window.pageYOffset || document.documentElement.scrollTop;

	if (st < 80) {
		header.classList.remove('internal')
	}
	if (st > 80) {
		if (st > lastScrollTop) {
			if (!document.getElementById('header').classList.contains('internal')) {
				document.getElementById('header').classList.add('internal')
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow() {
	//calculate a new window size
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

	//header image to be window height on homepage
	if (document.getElementsByClassName('img-slide').length > 0) {
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for (let i = 0; i < headerImagesLength; i++) {
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
}
